import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import SearchField from "shared/components/SearchField";
import { COLOR_GREY_5 } from "shared/theme/colors";

type ComboHeaderProps = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
};

const ComboHeader: FC<ComboHeaderProps> = ({ searchQuery, setSearchQuery }) => {
  return (
    <FlexCenter p="0.75rem" borderBottom={`1px solid ${COLOR_GREY_5}`}>
      <SearchField
        placeholder="Search"
        value={searchQuery}
        onChange={setSearchQuery}
      />
    </FlexCenter>
  );
};

export default ComboHeader;
